import R from 'ramda';
import React, { Component } from 'react';
import { Row, Col, FormGroup, Radio, Checkbox } from 'react-bootstrap';
import FontAwesome from 'react-fontawesome';
import { getMemberNameByUserId } from '../../utils';
import ChangeRequestsView from '../Deals/DealEditPages/ChangeRequestsView';

export default class LicensingPermissions extends Component {
  constructor(props) {
    super(props);
    this.state = { adjust: undefined, changes: {}, all: false };
  }

  options = () => ({
    field1: this.state.changes.field1,
    licenserIds: this.state.changes.licenserIds,
  });

  componentDidMount() {
    if (this.props.dealBlocks) {
      this.getBlockChanges(this.props.dealBlocks);
    }
  }

  componentWillReceiveProps(nextProps) {
    const { licenserIds, work, dealBlocks } = nextProps;

    if (licenserIds && work && work.work_ownership_info) {
      let all = true;
      work.work_ownership_info.forEach((member) => {
        all = all && licenserIds.indexOf(member.user) !== -1;
      });
      this.setState({ all });
    }

    if (dealBlocks) {
      this.getBlockChanges(dealBlocks);
    }
  }

  getBlockChanges(dealBlocks) {
    const block = R.find(R.propEq('id', this.props.block.id))(dealBlocks);
    if (block) {
      this.setState({
        changes: block.changes || {},
        adjust: block.accept ? !block.accept : block.changes ? true : undefined,
      });
    }
  }

  handleMember(e, id) {
    const { work } = this.props;
    const { licenserIds } = this.state.changes;
    let ids = [];

    if (id === 'all') {
      if (e.target.checked && work && work.work_ownership_info) {
        ids = work.work_ownership_info.map((member) => member.user);
      }
    } else {
      ids = licenserIds ? licenserIds.concat() : [];
      if (e.target.checked) {
        if (ids.indexOf(id) === -1) {
          ids.push(id);
        }
      } else {
        let index = ids.indexOf(id);
        if (index !== -1) {
          ids.splice(index, 1);
        }
      }
    }
    this.handleContent('licenserIds', ids);
  }

  handleContent(field, index) {
    const options = this.options();
    options[field] = index;

    let checked = true;
    if (options.field1 === 1) {
      checked = false;
      if (options.licenserIds && options.licenserIds.length) {
        checked = true;
      }
    } else if (options.field1 === 0) {
      options.licenserIds = [];
    }

    this.props.setBlockChanges({
      id: this.props.block.id,
      options,
      checked,
      content: '',
    });
  }

  getMemberChecked(id) {
    return (
      this.state.changes.licenserIds &&
      this.state.changes.licenserIds.indexOf(id) !== -1
    );
  }

  getMemberName() {
    const { field1, licenserIds, work, members } = this.props;

    if (field1 === 0) {
      return 'None';
    } else if (licenserIds) {
      const names = [];
      if (work && work.work_ownership_info) {
        work.work_ownership_info.forEach((member) => {
          if (licenserIds.indexOf(member.user) !== -1) {
            names.push(getMemberNameByUserId(member.user, members));
          }
        });
      }
      return names.join();
    } else {
      return 'None';
    }
  }

  handleAdjust(adjust) {
    this.setState({ adjust });

    if (!adjust) {
      this.props.removeBlockChanges(this.props.block.id);
    }
  }

  renderAdjust() {
    const { adjust, all, changes } = this.state;
    const { work, members } = this.props;

    if (adjust === true) {
      return (
        <div className="inner-content">
          <FormGroup className="answer">
            <Radio
              name="permissions"
              checked={changes.field1 === 0}
              readOnly
              onClick={(e) => this.handleContent('field1', 0)}
            >
              None
            </Radio>
            <Radio
              name="permissions"
              checked={changes.field1 === 1}
              readOnly
              onClick={(e) => this.handleContent('field1', 1)}
            >
              Select applicable collaborators
            </Radio>

            {changes.field1 === 1 ? (
              <FormGroup className="answer">
                <Checkbox
                  checked={all === true}
                  onChange={(e) => this.handleMember(e, 'all')}
                >
                  Select All
                </Checkbox>
                {work &&
                  work.work_ownership_info &&
                  work.work_ownership_info.map((member, i) => (
                    <Checkbox
                      key={i}
                      checked={this.getMemberChecked(member.user)}
                      onChange={(e) => this.handleMember(e, member.user)}
                    >
                      {getMemberNameByUserId(member.user, members)}
                    </Checkbox>
                  ))}
              </FormGroup>
            ) : null}
          </FormGroup>
        </div>
      );
    } else {
      return null;
    }
  }

  renderChangeRequest(changeRequest) {
    const { work, members } = this.props;

    if (changeRequest.changes.field1 === 0) {
      return 'None';
    } else if (changeRequest.changes.licenserIds) {
      const names = [];
      if (work && work.work_ownership_info) {
        work.work_ownership_info.forEach((member) => {
          if (changeRequest.changes.licenserIds.indexOf(member.user) !== -1) {
            names.push(getMemberNameByUserId(member.user, members));
          }
        });
      }
      return names.join();
    } else {
      return 'None';
    }
  }

  renderChangeRequests() {
    return (
      <ChangeRequestsView
        changeRequests={this.props.changeRequests}
        renderChangeRequest={(changeRequest) =>
          this.renderChangeRequest(changeRequest)
        }
      />
    );
  }

  render() {
    return (
      <div className="tab-content">
        <Row>
          {!this.props.finalized && !this.props.isAttorney && (
            <Col sm={12}>
              <p className="question">
                Which collaborators may enter into direct, non-exclusive
                licenses on behalf of the other collaborators?
              </p>
              <FormGroup className="answer">
                <Radio
                  name="permissions-adjust"
                  checked={this.state.adjust === false}
                  readOnly
                  onClick={(e) => this.handleAdjust(false)}
                >
                  {this.props.userInfo.same
                    ? `Keep my original proposal: `
                    : `Accept ${this.props.userInfo.name} 's proposed terms: `}
                  {this.getMemberName()}
                </Radio>
                <hr />
                <Radio
                  name="permissions-adjust"
                  checked={this.state.adjust === true}
                  readOnly
                  onClick={(e) => this.handleAdjust(true)}
                >
                  {this.props.userInfo.same
                    ? `Change my proposal:`
                    : `Suggest an alternative:`}
                </Radio>
              </FormGroup>
              {this.renderAdjust()}
              {this.props.renderAccepts()}
              {this.renderChangeRequests()}
            </Col>
          )}
          {!this.props.finalized && !this.props.isAttorney && (
            <Col sm={12}>{this.props.children}</Col>
          )}

          <Col sm={12}>
            <div className="notes">
              <h4>
                <FontAwesome name="question-circle" />
                Need Some Help?
              </h4>
              <div className="expand" tabIndex="0">
                <p className="question">Why is this important?</p>
                <p className="small">
                  Taking the time now to state who has permission to license
                  your work(s) helps you to avoid serious legal and financial
                  issues caused by the sale/use of your work(s) without proper
                  permission (e.g. collaborators licensing your work(s) to
                  others or for fees that you would not normally approve of).
                </p>
              </div>
              <div className="expand" tabIndex="0">
                <p className="question">What is a "direct license"?</p>
                <p className="small">
                  A "direct license" is a license that is obtained directly by
                  the owners of a work instead of from a third party.
                </p>
              </div>
              <div className="expand" tabIndex="0">
                <p className="question">What does non-exclusive mean?</p>
                <p className="small">
                  "Non-exclusive" means that a specific action is not solely
                  restricted or reserved to a specific party. In a non-exclusive
                  arrangement, multiple parties can perform the same action,
                  such as sell or license a work.
                </p>
              </div>
            </div>
          </Col>
        </Row>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// src/components/DealContractBlock/LicensingPermissions.jsx